import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { isAxiosError, isChat42Error } from "@/core/error";
import ErrorView from "./ErrorView";


interface ErrorFallbackProps {
    error: Error;
    clearError: (...args: Array<unknown>) => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, clearError }) => {
    const intl = useIntl();

    const code = useMemo(() => {
        if (isAxiosError(error)) {
            return error.status;
        }
        if (isChat42Error(error)) {
            return error.code;
        }
        return null;
    }, [error]);

    const errorMessage = useMemo(() => {
        if (code === 403) {
            return intl.formatMessage({ id: "e0002" });
        } else if (code === 404) {
            return intl.formatMessage({ id: "e0003" });
        } else {
            return intl.formatMessage({ id: "e0004" }, { code });
        }
    }, [code, intl]);

    return (
        <ErrorView description={errorMessage}
                   resetErrorBoundary={clearError}
        />
    );
};

export default ErrorFallback;
